import Customer from "./Customer";
import Relatives from "./Relatives";
import Senior from "./Senior";

const MembersList = ({ member, index, role, isSenior, mobileNumber, email, device_imei4, nurseringHome, lastName, homeAddress, department }: any) => {
    return (
        <ul className="members-list">
            {role === "customer" && <Customer member={member} isSenior={isSenior} />}
            {role === "senior" && <Senior member={member} />}
            {role === "member" && <Relatives member={member} index={index} role={role} />}
        </ul>
    );
};

export default MembersList;
